/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import PropTypes from 'prop-types';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  containerCss,
  selectContainerCss,
  selectCss,
  timeSelectContainerCss,
} from './index.styles';

const timeOptions = [
  '7:30 AM',
  '8:00 AM',
  '8:30 AM',
  '9:00 AM',
  '9:30 AM',
  '10:00 AM',
  '10:30 AM',
  '11:00 AM',
  '11:30 AM',
  '12:00 PM',
  '12:30 PM',
  '1:00 PM',
  '1:30 PM',
  '2:00 PM',
  '2:30 PM',
  '3:00 PM',
  '3:30 PM',
  '4:00 PM',
  '4:30 PM',
  '5:00 PM',
  '5:30 PM',
  '6:00 PM',
  '6:30 PM',
  '7:00 PM',
  '7:30 PM',
  '8:00 PM',
];

const defaultTime = '12:00 PM';

class TimePicker extends SafePureComponent {
  state = {
    time: defaultTime,
  };

  constructor(props) {
    super(props);

    this.timeRef = React.createRef();
    this.meridiemRef = React.createRef();
  }

  changeTime = () => {
    const index = this.timeRef.current.selectedIndex;
    const selectedOption = timeOptions[index];
    const [time, meridiem] = selectedOption.split(' ');
    this.setState({ time: selectedOption });
    this.props.onChange({ time, meridiem });
  };

  renderTimeSelect = () => {
    const { time } = this.state;
    return (
      <div css={[selectContainerCss, timeSelectContainerCss]}>
        {/* eslint-disable-next-line jsx-a11y/no-onchange */}
        <select css={selectCss} ref={this.timeRef} onChange={this.changeTime}>
          {timeOptions.map((timeOption, index) => (
            <option
              key={`time-option-${index}`}
              value={timeOption}
              selected={timeOption === time}
            >
              {timeOption}
            </option>
          ))}
        </select>
      </div>
    );
  };

  safeRender() {
    const { className } = this.props;
    return (
      <div className={className} css={containerCss}>
        {this.renderTimeSelect()}
      </div>
    );
  }
}

TimePicker.displayName = 'TimePicker';

TimePicker.propTypes = {
  onChange: PropTypes.func,
};

TimePicker.defaultProps = {
  onChange: () => {},
};

export default TimePicker;
